// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDriverExaminationSourceType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class DriverExaminationSourceType implements IDriverExaminationSourceType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
        Returns In Office DriverExaminationSourceType
    **/
    get InOffice(): IDriverExaminationSourceType {
        return this.FromId(1);
    }
    /**
        Returns In Office Written DriverExaminationSourceType
    **/
    get InOfficeWritten(): IDriverExaminationSourceType {
        return this.FromId(2);
    }
    /**
        Returns At Home DriverExaminationSourceType
    **/
    get AtHome(): IDriverExaminationSourceType {
        return this.FromId(4);
    }
    /**
        Returns Medical Review DriverExaminationSourceType
    **/
    get MedicalReview(): IDriverExaminationSourceType {
        return this.FromId(7);
    }
    /**
        Returns PDS - Operator School DriverExaminationSourceType
    **/
    get PDSOperatorSchool(): IDriverExaminationSourceType {
        return this.FromId(8);
    }
    /**
        Returns PDS - High School DriverExaminationSourceType
    **/
    get PDSHighSchool(): IDriverExaminationSourceType {
        return this.FromId(9);
    }
    /**
        Returns PDS - Motorcycle School DriverExaminationSourceType
    **/
    get PDSMotorcycleSchool(): IDriverExaminationSourceType {
        return this.FromId(10);
    }
    /**
        Returns PDS - Special Performance DriverExaminationSourceType
    **/
    get PDSSpecialPerformance(): IDriverExaminationSourceType {
        return this.FromId(11);
    }
    /**
        Returns PDS - Commercial School DriverExaminationSourceType
    **/
    get PDSCommercialSchool(): IDriverExaminationSourceType {
        return this.FromId(12);
    }
    /**
        Returns CSTIMS DriverExaminationSourceType
    **/
    get CSTIMS(): IDriverExaminationSourceType {
        return this.FromId(13);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'InOffice', displayValue: 'In Office', description: 'In Office', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'InOfficeWritten', displayValue: 'In Office Written', description: 'Written test taken in the office', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'AtHome', displayValue: 'At Home', description: 'At Home', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'MedicalReview', displayValue: 'Medical Review', description: 'Medical Review', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'PDSOperatorSchool', displayValue: 'PDS - Operator School', description: 'Professional driving school authorized by the state to deliver courses that will satisfy Non Commercial knowledge and skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'PDSHighSchool', displayValue: 'PDS - High School', description: 'High Schools authorized by the state to deliver courses that will satisfy Non Commercial knowledge and skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'PDSMotorcycleSchool', displayValue: 'PDS - Motorcycle School', description: 'Professional driving school authorized by the state to deliver courses that will satisfy Motorcycle knowledge and skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'PDSSpecialPerformance', displayValue: 'PDS - Special Performance', description: 'Professional driving school authorized by the state to deliver both Non Commercial and Motorcycle knowledge and skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'PDSCommercialSchool', displayValue: 'PDS - Commercial School', description: 'Professional driving school authorized by the state to deliver Commercial  skill tests.', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'CSTIMS', displayValue: 'CSTIMS', description: 'CSTIMS', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDriverExaminationSourceType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDriverExaminationSourceType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDriverExaminationSourceType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDriverExaminationSourceType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDriverExaminationSourceType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
